import "../../blocks/modules/header/header.js";
import "../../blocks/modules/index/index.js";
import "../../blocks/modules/mobile/mobile.js";